import { CSSProperties, ReactNode } from 'react';

export function Table({ children, style }: { children: ReactNode; style?: CSSProperties }) {
  return (
    <div className="lizzi-tabela-wrap" style={style}>
      <table className="lizzi-tabela">{children}</table>
    </div>
  );
}
